/**
 * Manager for a series of physics layers.
 * @module PhysicsLayerManager
 * @class PhysicsLayerManager
 * @param {Phaser.Scene} scene - scene in which this manager will operate
 */

import PhysicsLayer from "./physics-layer";

const PhysicsLayerManager = class {
    constructor ( scene ) {
        /**
         * Scene in which this manager operates.
         * @type {Phaser.Scene}
         */
        this.scene = scene;

        /**
         * List of physics layers.
         * @type {Array}
         */
        this.layers = [];
    }

    /**
     * Add an entity to a layer. Create the layer if necessary.
     * @param {GameSprite} entity - entity to add to a layer
     * @param {Number} layer - layer to which to add
     */
    addToLayer ( entity, layer ) {
        if ( !this.layers[ layer ] ) {
            this.layers[ layer ] = new PhysicsLayer( this.scene );
        }
        this.layers[ layer ].add( entity );
    }

    /**
     * Return all layers with the given child.
     * @param {GameSprite} child - child to check
     * @returns {Array}
     */
    getLayersWithChild ( child ) {
        return this.layers.filter( layer => {
            return layer.hasChild( child );
        } );
    }

    /**
     * Remove the given layer, and destroy all its physics.
     * @param {Number} index - index of layer to remove
     */
    removeLayer ( index ) {
        const layer = this.layers[ index ];
        if ( !layer ) {
            return;
        }
        layer.removeAll();
        this.layers.splice( index, 1 );
    }
};

export default PhysicsLayerManager;
